// extracted by mini-css-extract-plugin
export default {"cls1":"Axqgtf18f1NJuXWOsL3I","cls2":"a0R2WdyNgRVYyQaXkuwX Axqgtf18f1NJuXWOsL3I"};